import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-region",
  "use": "svg_i-region-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_i-region\"><path d=\"M11.2 1h.6A1.2 1.2 0 0 1 13 2.2v.6m0 8.4v.6a1.2 1.2 0 0 1-1.2 1.2h-.6m-8.4 0h-.6A1.2 1.2 0 0 1 1 11.8v-.6m0-8.4v-.6A1.2 1.2 0 0 1 2.2 1h.6\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol